// Shared by month and day screens. Public calendar data only; never user data.
const TTL_MS = 5 * 60 * 1000;
const MAX_MONTHS = 6;
const months = new Map<string, { value: any; expiresAt: number }>();
const pending = new Map<string, Promise<any>>();

export async function loadCalendarMonth(endpoint: string, parameters: Record<string, string | number>) {
  const params = { ...parameters };
  for (const key of ['lat', 'lon']) {
    if (params[key] !== undefined) params[key] = (Math.round(Number(params[key]) * 1000) / 1000).toFixed(3);
  }
  const query = new URLSearchParams();
  Object.keys(params).sort().forEach((key) => query.set(key, String(params[key])));
  const url = `${endpoint}?${query.toString()}`;
  const cached = months.get(url);
  if (cached && cached.expiresAt > Date.now()) {
    months.delete(url);
    months.set(url, cached);
    return cached.value;
  }
  months.delete(url);
  if (pending.has(url)) return pending.get(url)!;
  const request = (async () => {
    const response = await fetch(url);
    const value = await response.json();
    if (!response.ok || !value.success || !Array.isArray(value.data?.days)) {
      throw new Error(value.error || 'Unable to load Hindu Calendar.');
    }
    months.set(url, { value, expiresAt: Date.now() + TTL_MS });
    if (months.size > MAX_MONTHS) months.delete(months.keys().next().value!);
    return value;
  })().finally(() => pending.delete(url));
  pending.set(url, request);
  return request;
}
